import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { ArrayField, Datagrid, ReferenceField, TextField, FunctionField, SelectField } from "react-admin";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { AttestationStatusChoices } from "utils/choices";
import { AttestationStatus } from "utils/constants";

export const MissingAttestationsPanel = () => (
  <ArrayField source="attestations">
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
    >
      <ReferenceField
        label="Дисциплина"
        source="disciplineId"
        reference={administrationRequests.getDisciplinesSelect()}
        sortable={false}
      >
        <TextField
          source="name"
          label="Дисциплина"
        />
      </ReferenceField>
      <ReferenceField
        source="professorEmployeeId"
        reference={employeeRequests.getProfessorsSelect()}
        linkType={false}
        label="Преподавател"
      >
        <FunctionField render={getProfessorRecordText} />
      </ReferenceField>
      <FunctionField
        label="Статус"
        render={record => (
          <SelectField
            sx={{ color: record.status === AttestationStatus.Unverified ? "red" : "black" }}
            source="status"
            choices={AttestationStatusChoices}
          />
        )}
      />
    </Datagrid>
  </ArrayField>
);
